import React from 'react';

const Tokenomics = () => {
  const isMobile = window.innerWidth <= 768;

  // Common styles for text elements
  const textStyles = {
    fontFamily: 'VT323',
    textShadow: '0 2px 2px #000000',
    color: 'white',
    lineHeight: '1.4'
  };

  return (
    <div 
      id="tokenomics" 
      style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh', 
        paddingBottom: '150px' 
      }}
    >
      <div style={{ 
        maxWidth: isMobile ? '95%' : '800px', 
        padding: '30px',
        backgroundColor: 'rgba(0, 0, 0, 0.85)', // Semi-transparent black background
        borderRadius: '15px',
        boxShadow: '0 0 20px rgba(0, 143, 212, 0.3)', // Subtle blue glow
        border: '1px solid rgba(0, 143, 212, 0.2)' // Subtle blue border
      }}>
        <h1 style={{ 
          fontSize: isMobile ? '32px' : '48px', 
          textShadow: '0 5px #000000',
          marginBottom: '30px',
          color: '#008fd4',
          padding: '15px',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          borderRadius: '8px'
        }}>
          MiERO NFT Tokenomics
        </h1>

        <p style={{ 
          ...textStyles,
          fontSize: isMobile ? '20px' : '24px', 
          marginBottom: '40px',
          color: '#008fd4',
          padding: '15px',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          borderRadius: '8px'
        }}>
          The MiERO NFT is your exclusive pass into your digital self relating to health, 
          robotics, and the metaverse. Each NFT offers access to our innovative technology ecosystem. Visit and support our website to learn more. <a href="https://mieros.org" target="_blank" rel="noopener noreferrer">https://mieros.org</a>
        </p>

        <ul style={{ 
          listStyleType: 'none', 
          padding: '20px',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          borderRadius: '10px',
          margin: '0'
        }}>
          {[
            'Total Supply: 1,000,000 MiERO NFTs',
            'Mint Price: 0.005 ETH per MiERO NFT',
            'Potential Airdrops for Holders'
          ].map((item, index) => (
            <li key={index} style={{
              ...textStyles,
              fontSize: isMobile ? '18px' : '22px',
              padding: '12px 0',
              borderBottom: index !== 3 ? '1px solid rgba(0, 143, 212, 0.2)' : 'none',
              color: '#008fd4'
            }}>
              {item}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Tokenomics;
